export const MY_DIARY_GET_DIARY = "MY_DIARY_GET_DIARY";
export const MY_DIARY_GET_DIARY_SUCCESS = "MY_DIARY_GET_DIARY_SUCCESS";
export const UPDATE_MY_DIARY_FILTER_RANGE = "UPDATE_MY_DIARY_FILTER_RANGE";
export const UPDATE_MY_DIARY_FILTER_DEFAULT = "UPDATE_MY_DIARY_FILTER_DEFAULT";
export const MY_DIARY_SUBMIT_FORM_DATA = "MY_DIARY_SUBMIT_FORM_DATA";
export const MY_DIARY_SUBMIT_FORM_DATA_SUCCESS = "MY_DIARY_SUBMIT_FORM_DATA_SUCCESS";